const wording = {
  NoAccessSubtitle: "Vous n'avez pas les droits pour accéder à cette page",
  NoAccessTitle: 'Accès à cette page non autorisé',
};

export default wording;
